export const generateEmailHeader =
  (): string => `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">
<html data-editor-version="2" class="sg-campaigns" xmlns="http://www.w3.org/1999/xhtml">
  <head>
    <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1" />
    <meta http-equiv="X-UA-Compatible" content="IE=Edge" />
  </head>
  <body style="margin: 0; padding: 0; font-family: Arial, sans-serif; line-height: 1.6; color: #2E2E2E; background-color: #eaeef2; padding-top: 16px">
    <table cellpadding="0" cellspacing="0" width="100%" style="max-width: 600px; margin: 0 auto; padding: 20px; background-color: white; border-radius:8px; font-size: 16px;">`;

export const generateEmailFooter = (senderImageURL: string): string => `
  <tr>
    <td align="left">
      <img src="${senderImageURL}" alt="Sender Logo" style="width: 150px; height: 35px;">
    </td>
  </tr>
</table>
</body>
</html>`;

export const generateEmailFooterWithBlueDot = (
  senderImageURL: string,
): string => `
  <tr>
    <td align="left" style="display: flex; justify-content: space-between;">
      <img src="${senderImageURL}" alt="Sender Logo" style="width: 150px; height: 35px;">
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_8248_71)">
          <path d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z" fill="#00BCDA"/>
          <path d="M34.7229 39.5V37.4317H34V37H35.988V37.4317H35.2651V39.5H34.7229Z" fill="#00BCDA"/>
          <path d="M36.4699 39.5V37H37.1124L37.8454 38.506L38.5683 37H39.2108V39.5H38.6787V37.9036L38.0663 39.1486H37.6345L37.012 37.9036V39.5H36.4699Z" fill="#00BCDA"/>
          </g>
          <defs>
          <clipPath id="clip0_8248_71">
          <rect width="40" height="40" fill="white"/>
          </clipPath>
          </defs>
      </svg>
    </td>
  </tr>
</table>
</body>
</html>`;

export const generateMediaHtml = (
  isImageMedia: boolean,
  mediaUrl: string,
  mediaExtraImageURL: string,
  fallbackVideoUrl: string,
  fallbackThumbnailUrl: string,
): string => {
  if (isImageMedia && mediaUrl) {
    return `
      <div style="position: relative; width: 400px; margin: 0 auto;">
        <img src="${mediaUrl}" alt="Remo Conference Preview" style="width: 400px; border: 1px solid #eaeaea; border-radius: 8px;">
      </div>
    `;
  }

  const videoUrl = mediaUrl || fallbackVideoUrl;
  const thumbnailUrl = mediaExtraImageURL || fallbackThumbnailUrl;

  return `
    <a href="${videoUrl}">
      <div style="position: relative; width: 400px; margin: 0 auto;">
        <img src="${thumbnailUrl}" alt="Remo Conference Preview" style="width: 400px; border: 1px solid #eaeaea; border-radius: 8px;">
        <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#00BCDA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10" fill="#00BCDA"/>
            <polygon points="10 8 16 12 10 16 10 8" stroke="white" fill="white"/>
          </svg>
        </div>
      </div>
    </a>
  `;
};

export const generateChecklistHtml = (
  geartestUrl: string,
  guestGuideUrl: string,
  useAlternativeHeader?: boolean,
): string => `
${
  useAlternativeHeader
    ? `<p style="margin: 0 0 15px 0;">This is a Webcam & Microphone required event. To ensure a smooth event experience, please go through our pre-event checklist:</p>`
    : `<p style="margin: 0 0 15px 0; font-weight: bold;">Pre-Event Checklist:</p>`
}
  <ol style="margin: 0; padding: 0 0 0 20px;">
    <li style="margin-bottom: 20px;">
      Test your mic/cam and system settings with our 
      <a href="${geartestUrl}" style="color: #00BCDA; text-decoration: underline;">geartest tool here</a>
      <p style="margin: 5px 0 0; font-style: italic;">NOTE: Events.com Virtual (formerly Remo) is best experienced on Chrome, Safari, or Edge on a desktop/laptop.</p>
    </li>
    <li style="margin-bottom: 20px;">
      Watch this <a href="${guestGuideUrl}" style="color: #00BCDA; text-decoration: underline;">30 second video</a> on how to use Events.com Virtual (formerly Remo)
    </li>
    <li style="margin-bottom: 20px;">
      Check out our "<a href="${guestGuideUrl}" style="color: #00BCDA; text-decoration: underline;">Using Events.com Virtual (formerly Remo) as a Guest</a>" guide for all the ins and outs.
    </li>
    <li>
      Facing a technical issue? Click "Need Help" in the bottom left corner to reach Events.com Virtual (formerly Remo) Support Team
    </li>
  </ol>
`;

export const disableLinks = (html: string): string => {
  const styleTag = `<style>
    a {
      pointer-events: none;
      cursor: default;
    }
  </style>`;

  return html.replace("</head>", `${styleTag}</head>`);
};
